import { EMPTY } from "./RegEx";
import {
  dataPrecisions,
  arrayDataPrecisions,
  conditionalDataPrecision,
} from "./components/Catalogue/sourceCatlogueDesc";

import { PLOT_X_AXIS } from "./constants";

export const isEmptyString = (value) => {
  const EMPTYRegEx = new RegExp(EMPTY);
  return EMPTYRegEx.test(value);
};

export const checkIfEmpty = (obj) => {
  return Object.values(obj).filter((value) => value !== "").length === 0
    ? true
    : false;
};
export const checkIfEmptyObj = (obj) =>
  Object.keys(obj).length == 0 ? true : false;

export const checkIfExistsAndNotEmpty = (value) => {
  return value && !isEmptyString(value);
};

export const checkIfObjectHasNonNullValues = (obj) => {
  return Object.values(obj).filter((value) => value !== null).length === 0
    ? false
    : true;
};

export const checkIfObjectHasAllEmptyStringValues = (obj) => {
  return Object.values(obj).filter((value) => value !== "").length === 0
    ? true
    : false;
};

function hasJsonStructure(str) {
  if (typeof str !== "string") return false;
  try {
    const result = JSON.parse(str);
    const type = Object.prototype.toString.call(result);
    return type === "[object Object]" || type === "[object Array]";
  } catch (err) {
    return false;
  }
}

export function transformOptions(arrValues){
  return arrValues.map((el)=>({value:el,label:el}));
}
export const formatData = (key, value) => {
  if (isEmptyString(value)) {
    return "...";
  }

  if (dataPrecisions[key]) {
    return parseFloat(value).toFixed(dataPrecisions[key]);
  }

  if (arrayDataPrecisions[key]) {
    try {
      let values = typeof value === "string" ? JSON.parse(value) : value;
      return JSON.stringify(
        values.map((v) =>
          parseFloat(parseFloat(v).toFixed(arrayDataPrecisions[key]))
        )
      );
    } catch (e) {
      return value;
    }

  }
  if(conditionalDataPrecision[key]){
    const {predicate,precision}=conditionalDataPrecision[key];
    return predicate(value) ? parseFloat(value).toFixed(precision) : value
  }
  if(typeof value === 'boolean') {
    return value.toString();
  }

  return value;
};

export function tranformOptionsForRequest(arr){
  return arr.map(item=>item.value);
}

export function getPlotAxis(spectralPlotData) {
  
  let plotAxis = {
    Y: {
      header: "csubflux(Jy/b)",
      label: "csubflux(Jy/b)"
    },
    X: {
      header: "Invalid",
      label: "Invalid"
    }
  };

  if(spectralPlotData && spectralPlotData?.length > 0) {
    const headers = Object.keys(spectralPlotData[0]);

    if(headers.indexOf(PLOT_X_AXIS.frequency.header) != -1) {
      plotAxis.X = PLOT_X_AXIS.frequency;
    }

    else if(headers.indexOf(PLOT_X_AXIS.velocity.header) != -1) {
      plotAxis.X = PLOT_X_AXIS.velocity;
    }
  }
  
  return plotAxis;
}
